export class ConfirmLostPasswordRequest {
    code: string = '';
    password: string = '';
}